module.exports = __webpack_public_path__ + "images/category_lp/common/icon-company-1_1a3119c92ee8eb63dac32b9266fff877.png";